import { createContext, useState } from 'react';

export const AuthContext = createContext();

const safeParseUser = () => {
  try {
    const raw = localStorage.getItem('user');
    if (!raw || raw === 'null' || raw === 'undefined') return null;
    return JSON.parse(raw);
  } catch (e) {
    console.warn('Failed to parse user from localStorage', e);
    return null;
  }
};

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('access_token') || null); // access token
  const [refresh, setRefresh] = useState(localStorage.getItem('refresh_token') || null);
  const [user, setUser] = useState(safeParseUser());
  const [currentUser, setCurrentUser] = useState(safeParseUser()); // alias for compatibility

  const login = (tokens = {}) => {
    const access = tokens.access || null;
    const ref = tokens.refresh || null;

    if (access) {
      localStorage.setItem('access_token', access);
      setToken(access);
    }
    if (ref) {
      localStorage.setItem('refresh_token', ref);
      setRefresh(ref);
    }
    // if API returns user object include it; otherwise fetch profile after login
    if (tokens.user) {
      try {
        localStorage.setItem('user', JSON.stringify(tokens.user));
        setUser(tokens.user);
        setCurrentUser(tokens.user);
      } catch (e) {
        console.warn('Failed to store user', e);
      }
    }
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    setToken(null);
    setRefresh(null);
    setUser(null);
    setCurrentUser(null);
  };

  return (
    <AuthContext.Provider value={{ token, refresh, user, currentUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
